
import { defineComponent, onBeforeMount, ref } from 'vue';
// import modal from '@/components/global/GenericModal.vue';
import moment from 'moment';
// eslint-disable-next-line
import { invokegetAllProgram, invokegetAllTaskByProgram, invokeArchieveTask, uploadBulkTasks, importBulkTask } from '@/utils/admin/task_management_service';
// eslint-disable-next-line
import { resetActiveTaskSequence, invokeExportTask } from '@/utils/admin/task_management_service';
// eslint-disable-next-line
import router from '@/router';
import Generic from '@/components/global/GenericModal.vue';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { getPreSignedUrl } from '@/utils/learner_submit_service';
import { invokegetSkillProf } from '@/utils/admin/assign_proxy_service';
import SearchBar from '@/components/global/SearchBar.vue';

export default defineComponent({
  name: 'TaskManagement',
  components: { Generic, SearchBar },

  setup() {
    const programDetails = ref();
    const renderReady = ref(true);
    const taskDetails = ref();
    const taskCheckOne = ref([]);
    const selectedProgram = ref('Select Program');
    const taskBtn = ref();
    const checkedTaskId = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const showTaskImport = ref(false);
    const showTaskImportBtn = ref(false);
    const bulkTaskFileName = ref();
    const bulkTaskFile = ref();
    const errorMessage = ref();
    const successMessage = ref();
    const preSignedUrl = ref();
    const archiveBtn = ref(false);
    const unArchiveBtn = ref();
    const archiveType = ref();
    const skills = ref();
    const proficiency = ref();
    const selectedSkill = ref('Select Skill');
    const selectedProficiency = ref('Select Proficiency');
    const showSkillProf = ref(false);
    const searchBtn = ref(false);
    const showSequencBtn = ref(false);
    const singleTaskBtn = ref(false);
    const showSingleTaskImport = ref(false);
    const showExportBtn = ref(false);
    const SinglesuccessMessage = ref();
    const BulksuccessMessage = ref();
    const modalVisible = ref(false);
    const modalMessage = ref();
    const modalButtonVisible = ref(false);
    const taskData = {};
    const taskDetailsArray = ref();
    const filteredTaskDetails = ref();
    const showArchivedTasks = ref(false);

    let archiveData;
    const taskcheckedOne = () => {
      taskCheckOne.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showTaskBtn = (event: any, taskId: any, isArchive: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        checkedTaskId.value = taskId;
        taskBtn.value = true;
        singleTaskBtn.value = true;
        if (isArchive === true) {
          archiveType.value = false;
          archiveBtn.value = false;
          unArchiveBtn.value = true;
        } else {
          archiveType.value = true;
          archiveBtn.value = true;
          unArchiveBtn.value = false;
        }
      } else {
        taskBtn.value = false;
        archiveBtn.value = false;
        unArchiveBtn.value = false;
        singleTaskBtn.value = false;
        showSingleTaskImport.value = false;
      }
    };
    const getTaskDetails = async () => {
      renderReady.value = false;
      // if (taskData.program_id !== 'Select Program') {
      taskDetails.value = await invokegetAllTaskByProgram('/getAllTaskByProgram', taskData);
      taskDetailsArray.value = taskDetails.value.map((Task) => Task.task_name);
      filteredTaskDetails.value = taskDetails.value;
      console.log('taskDetailsArray', taskDetailsArray);
      // localStorage.removeItem('program');
      // localStorage.removeItem('skill');
      // localStorage.removeItem('proficiency');
      for (let index = 0; index < taskDetails.value.length; index += 1) {
        const res = taskDetails.value[index];
        if (res.created_date) {
          // res.created_date = moment(res.created_date).format('DD-MM-YYYY');
          res.created_date = moment(res.created_date).format('MMM Do YYYY, h:mm a');
          res.modified_date = moment(res.modified_date).format('MMM Do YYYY, h:mm a');
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      taskDetails.value = taskDetails.value.sort((a: any, b: any) => a.task_name.localeCompare(b.task_name));
      if (selectedProgram.value === 'infinity') {
        showSequencBtn.value = false;
      } else {
        showSequencBtn.value = true;
      }
      // }
      renderReady.value = true;
    };
    const searchTask = async () => {
      if (selectedProgram.value !== 'Select Program') {
        Object.assign(taskData, { program_id: selectedProgram.value });
      }
      if (selectedSkill.value !== 'Select Skill') {
        Object.assign(taskData, { skill_id: selectedSkill.value });
      }
      if (selectedProficiency.value !== 'Select Proficiency') {
        Object.assign(taskData, { proficiency_id: selectedProficiency.value });
      }
      if (selectedProgram.value !== 'Select Program') {
        taskBtn.value = false;
        archiveBtn.value = false;
        unArchiveBtn.value = false;
        taskBtn.value = false;
        singleTaskBtn.value = false;
        await getTaskDetails();
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProgram = async (e: any) => {
      renderReady.value = false;
      localStorage.setItem('program', e.target.value);

      localStorage.removeItem('skill');
      localStorage.removeItem('proficiency');
      selectedProgram.value = e.target.value;
      if (selectedProgram.value !== 'Select Program') {
        showTaskImportBtn.value = true;
        showExportBtn.value = true;
        searchBtn.value = true;
        if (selectedProgram.value === 'infinity') {
          showSequencBtn.value = false;
          selectedSkill.value = 'Select Skill';
          selectedProficiency.value = 'Select Proficiency';
          showSkillProf.value = true;
          // showSequencBtn.value = false;
        } else {
          showSkillProf.value = false;
          selectedSkill.value = '';
          selectedProficiency.value = '';
          showSequencBtn.value = true;
        }
        // localStorage.setItem('inputValue', selectedProgram.value);
        // await getTaskDetails();
      } else {
        showTaskImportBtn.value = false;
        showTaskImport.value = false;
        searchBtn.value = false;
        showExportBtn.value = false;
        showSkillProf.value = false;
      }
      renderReady.value = true;
      // localStorage.setItem('program', selectedProgram.value);
      // localStorage.removeItem('inputValue');
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      localStorage.setItem('skill', e.target.value);
      selectedSkill.value = e.target.value;
      if (selectedSkill.value === 'Select Skill') {
        selectedSkill.value = '';
      }
      // localStorage.setItem('skill', selectedSkill.value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      localStorage.setItem('proficiency', e.target.value);
      selectedProficiency.value = e.target.value;
      if (selectedProficiency.value === 'Select Proficiency') {
        selectedProficiency.value = '';
      }
    };
    const getProgram = async () => {
      renderReady.value = false;
      programDetails.value = await invokegetAllProgram('/cache?cache=program');
      // console.log(programDetails.value);
      renderReady.value = true;
    };
    const viewTaskDetails = async () => {
      // if (programAdmin.value.includes(loggedInUser.value)) {
      //   localStorage.setItem('programAdmin', 'true');
      // } else {
      //   localStorage.setItem('programAdmin', 'false');
      // }
      router.push({ name: 'SolidifyAdministrationTaskDetails', query: { task_id: checkedTaskId.value } });
      // alert(checkedTaskId.value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        const file = event.target.files[0];
        const fileName = file.name;
        const isFileCSV = fileName.endsWith('.csv');
        if (!isFileCSV) {
          errorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
          bulkTaskFile.value = null;
          bulkTaskFileName.value = null;
        } else {
          bulkTaskFileName.value = fileName;
          bulkTaskFile.value = file;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const bulkSingleImportTask = async () => {
      if (!bulkTaskFile.value) {
        errorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else {
        const now = moment().format('llll');
        renderReady.value = false;
        const keyName = `${selectedProgram.value}_${now}.csv`;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
          folder_name: 'task_import',
          key_name: keyName,
        });
        console.log('presigned URL', preSignedRes);
        preSignedUrl.value = preSignedRes.data.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadBulkTasks(preSignedUrl.value, bulkTaskFile.value);
        if (uploadedRes.status === 200) {
          const bulkImportObj = {
            task_id: checkedTaskId.value,
            file_key: `${keyName}`,
          };
          const importList = await importBulkTask('/task/importSingleTask', bulkImportObj);
          console.log(importList);
          renderReady.value = false;
          SinglesuccessMessage.value = 'Task Updated';
          bulkTaskFile.value = null;
          bulkTaskFileName.value = null;
          taskDetails.value = await invokegetAllTaskByProgram('/getAllTaskByProgram', { program_id: selectedProgram.value });
          renderReady.value = true;
          setTimeout(() => {
            SinglesuccessMessage.value = null;
            showSingleTaskImport.value = false;
          }, 6000);
        }
      }
    };
    const bulkImportTask = async () => {
      if (!bulkTaskFile.value) {
        errorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else {
        const now = moment().format('llll');
        renderReady.value = false;
        const keyName = `${selectedProgram.value}_${now}.csv`;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
          folder_name: 'task_import',
          key_name: keyName,
        });
        console.log('presigned URL', preSignedRes);
        preSignedUrl.value = preSignedRes.data.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadBulkTasks(preSignedUrl.value, bulkTaskFile.value);
        if (uploadedRes.status === 200) {
          const bulkImportObj = {
            program_id: selectedProgram.value,
            file_key: `${keyName}`,
          };
          const importList = await importBulkTask('/task/import', bulkImportObj);
          console.log(importList);
          renderReady.value = false;
          BulksuccessMessage.value = 'Task added';
          bulkTaskFile.value = null;
          bulkTaskFileName.value = null;
          taskDetails.value = await invokegetAllTaskByProgram('/getAllTaskByProgram', { program_id: selectedProgram.value });
          renderReady.value = true;
          setTimeout(() => {
            BulksuccessMessage.value = null;
            showTaskImport.value = false;
          }, 6000);
        }
      }
    };
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };
    const resetTaskOrder = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const programId = selectedProgram.value;
      if (programId !== 'infinity') {
        await resetActiveTaskSequence('/resetActiveTaskOrder ', { program_id: programId });
      }
      await getTaskDetails();
      // if (taskDetails.value.length > 0) {
      //   const filteredRecords = taskDetails.value.filter((obj: any) => obj.is_archive === false);
      //   for (let index = 0; index < filteredRecords.length; index += 1) {
      //     const res = filteredRecords[index];
      //     res.task_order = index + 1;
      //     res.created_date = moment(res.created_date).utc().format();
      //   }
      //   if (filteredRecords.length > 0) {
      //   }
      // }
    };
    const archieveTask = async () => {
      renderReady.value = false;
      archiveData = {
        task_id: checkedTaskId.value,
        archive_type: archiveType.value,
      };
      modalVisible.value = true;
      if (archiveData.archive_type) {
        modalMessage.value = 'Archiving a task also archives linked offcycle tasks. Please confirm if you want to proceed.';
      } else {
        modalMessage.value = 'Unarchiving a task also unarchives linked offcycle tasks. Please confirm if you want to proceed.';
      }
      modalButtonVisible.value = true;
      renderReady.value = true;
    };
    const createOffCycle = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const programDetail = programDetails.value.find((program: any) => program.program_id === selectedProgram.value);
      console.log(`programDetail ${JSON.stringify(programDetail)}`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const taskDetail = taskDetails.value.find((task: any) => task.task_id === checkedTaskId.value);
      console.log(`taskDetail ${JSON.stringify(taskDetail)}`);
      console.log('programId', selectedProgram.value);
      console.log('programName', programDetail.program_name);
      console.log('linkedTaskId', checkedTaskId.value);

      console.log('taskName', taskDetail.task_name);
      console.log('taskType', taskDetail.task_type);
      localStorage.setItem('programId', selectedProgram.value);
      localStorage.setItem('programName', programDetail.program_name);
      localStorage.setItem('linkedTaskId', checkedTaskId.value);
      if (selectedProgram.value === 'infinity') {
        localStorage.setItem('skillId', selectedSkill.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const skillDetail = skills.value.find((skill: any) => skill.skill_id === selectedSkill.value);
        console.log(`skillDetail ${JSON.stringify(skillDetail)}`);
        localStorage.setItem('skillName', skillDetail.skill_alias);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const profDetail = proficiency.value.find((prof: any) => prof.prof_id === selectedProficiency.value);
        console.log(`profDetail ${JSON.stringify(profDetail)}`);
        localStorage.setItem('proficiencyId', selectedProficiency.value);
        localStorage.setItem('proficiencyName', profDetail.prof_name);
        console.log('skill', selectedSkill.value);
        console.log('skill Name', skillDetail.skill_alias);
        console.log('proficiency', selectedProficiency.value);
        console.log('prof Name', profDetail.prof_name);
      }
      localStorage.setItem('taskName', taskDetail.task_name);
      localStorage.setItem('taskType', taskDetail.task_type);
      router.push({ name: 'SolidifyAdministrationCreateOffCycle' });
    };
    const exportTask = async () => {
      renderReady.value = false;
      successMessage.value = 'The task report is being processed. You should get that over email in next 15 minutes';
      setTimeout(() => {
        successMessage.value = null;
      }, 6000);
      // console.log(programDetails.value);
      renderReady.value = true;
      await invokeExportTask(selectedProgram.value);
    };
    const closeModal = () => {
      modalVisible.value = false;
    };
    const archieveTaskFunction = async () => {
      renderReady.value = false;
      modalVisible.value = false;
      await invokeArchieveTask('/archieveTask', archiveData);
      console.log('inside archieveTask');
      await resetTaskOrder();
      archiveBtn.value = false;
      unArchiveBtn.value = false;
      taskBtn.value = false;
      // taskDetails.value = await invokegetAllTaskByProgram('/getAllTaskByProgram', { program_id: selectedProgram.value });
      taskCheckOne.value = [];
      renderReady.value = true;
    };
    const getFilteredList = (value) => {
      // filteredProgramDetails.value = value;
      // console.log('ProgramDetails.value in final', ProgramDetails.value);
      filteredTaskDetails.value = taskDetails.value.filter((task) => value.includes(task.task_name) && task.is_archive === showArchivedTasks.value);
      console.log('filteredTaskDetails', filteredTaskDetails.value);
    };
    const filterArchivedTasks = (isArchive: boolean) => {
      showArchivedTasks.value = isArchive;
      if (isArchive) {
        filteredTaskDetails.value = taskDetails.value.filter((task) => task.is_archive === true);
      } else {
        filteredTaskDetails.value = taskDetails.value.filter((task) => task.is_archive !== true);
      }
    };
    onBeforeMount(async () => {
      // const prevRoute = router.back();
      // console.log('Previous Route', prevRoute);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');

      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access') || userRole.value.includes('Community Manager') || userRole.value.includes('Program Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
      localStorage.removeItem('programId');
      localStorage.removeItem('programName');
      localStorage.removeItem('linkedTaskId');
      localStorage.removeItem('skillId');
      localStorage.removeItem('skillName');
      localStorage.removeItem('proficiencyId');
      localStorage.removeItem('proficiencyName');
      localStorage.removeItem('taskName');
      localStorage.removeItem('taskType');
      await getProgram();
      await getSkillandProf();
      if (localStorage.getItem('program')) {
        selectedProgram.value = localStorage.getItem('program') || 'Select Program';
        Object.assign(taskData, { program_id: localStorage.getItem('program') });
      }
      if (localStorage.getItem('skill')) {
        selectedSkill.value = localStorage.getItem('skill') || 'Select Skill';
        Object.assign(taskData, { skill_id: localStorage.getItem('skill') });
      }
      if (localStorage.getItem('proficiency')) {
        selectedProficiency.value = localStorage.getItem('proficiency') || 'Select Proficiency';
        Object.assign(taskData, { proficiency_id: localStorage.getItem('proficiency') });
      }
      console.log('Local Storage Value', taskData);
      // selectedProgram.value = localStorage.getItem('program') || 'Select Program';
      // selectedSkill.value = localStorage.getItem('skill');
      // selectedProficiency.value = localStorage.getItem('proficiency');
      // if (selectedProgram.value) {
      if (localStorage.getItem('program') !== 'Select Program') {
        showExportBtn.value = true;
        showTaskImportBtn.value = true;
        await getTaskDetails();
        filterArchivedTasks(showArchivedTasks.value);
      }
      searchBtn.value = true;
      if (selectedProgram.value === 'infinity') {
        showSkillProf.value = true;
        showSequencBtn.value = false;
      } else {
        showSkillProf.value = false;
      }
      // } else {
      //   searchBtn.value = false;
      // }

      // if (localStorage.getItem('inputValue')) {
      //   selectedProgram.value = localStorage.getItem('inputValue');
      //   renderReady.value = false;
      //   // selectedProgram.value = localStorage.getItem('inputValue');
      //   taskDetails.value = await invokegetAllTaskByProgram('/getAllTaskByProgram', { program_id: localStorage.getItem('inputValue') });
      //   renderReady.value = true;
      //   localStorage.removeItem('inputValue');
      //   // selectedProgram.value = '';
      //   taskCheckOne.value = [];
      // }
    });
    return {
      renderReady,
      programDetails,
      getSelectedProgram,
      taskDetails,
      taskCheckOne,
      taskcheckedOne,
      checkedTaskId,
      showTaskBtn,
      taskBtn,
      viewTaskDetails,
      showScreen,
      archieveTask,
      selectedProgram,
      showTaskImport,
      showTaskImportBtn,
      bulkImportTask,
      selectedFile,
      errorMessage,
      successMessage,
      archiveBtn,
      unArchiveBtn,
      getTaskDetails,
      skills,
      proficiency,
      getSelectedSkill,
      getSelectedProficiency,
      showSkillProf,
      searchBtn,
      resetTaskOrder,
      showSequencBtn,
      createOffCycle,
      selectedSkill,
      selectedProficiency,
      searchTask,
      singleTaskBtn,
      showSingleTaskImport,
      bulkSingleImportTask,
      exportTask,
      showExportBtn,
      SinglesuccessMessage,
      BulksuccessMessage,
      modalVisible,
      modalMessage,
      closeModal,
      modalButtonVisible,
      archieveTaskFunction,
      taskDetailsArray,
      getFilteredList,
      filteredTaskDetails,
      filterArchivedTasks,
      showArchivedTasks,
    };
  },
});
